import React, { useState, useEffect } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import axios from "axios";
import { BaseUrl } from "../App";
import { Circles } from 'react-loader-spinner';
import { FadeLoader } from 'react-spinners';


const SchedulePage_s = () => {
  const [activeTab, setActiveTab] = useState("VIEW SLOTS BY ? ");
  const [scheduleType, setScheduleType] = useState(null);
  const [availabilityData, setAvailabilityData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [selectedWeek, setSelectedWeek] = useState("1"); // Add state for selected week
  const [breakToDelete, setBreakToDelete] = useState(null); // Track the break to delete
  const [showModal, setShowModal] = useState(false);
  const [breakData, setBreakData] = useState([]); // Added state for breaks data
  const [startTime, setStartTime] = useState(""); // Store start time
  const [endTime, setEndTime] = useState(""); // Store end time
  const [selectedWeekId, setSelectedWeekId] = useState("1"); // Store selected week id
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Track modal visibility
  const [showDeleteModaloff, setShowDeleteModaloff] = useState(false);
  const [selectedBreakId, setSelectedBreakId] = useState(null); // Store the break id to delet
  const [startDateTime, setStartDateTime] = useState(""); // For start date & time
  const [endDateTime, setEndDateTime] = useState(""); // For end date & time
  const [offTimes, setOffTimes] = useState([]); // To store off time
  const [selectedDate, setSelectedDate] = useState(null); // New state to store selected date
  const [fullMonth, setFullMonth] = useState({});
  const [offDays, setOffDays] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [breakTimes, setBreakTimes] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const toggleMonth = async (month) => {
    const isMonthSelected = fullMonth[month];
    // setLoading(true);
    // Toggle month selection
    setFullMonth((prev) => ({
      ...prev,
      [month]: !isMonthSelected,
    }));
  

    useEffect(() => {
      let timer;
      if (error) {
        timer = setTimeout(() => {
          setError("");
        }, 5000); // 5 seconds
      }
      return () => clearTimeout(timer);
    }, [error]);
    // Get current date and month
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // Current month index (0-11)
    const currentYear = currentDate.getFullYear(); // Current year
  
    // Get selected month index (0-11)
    const selectedMonthIndex = months.indexOf(month);
    
    // Check if the selected month is in the past
    if (selectedMonthIndex < currentMonth && currentYear === new Date().getFullYear()) {
      alert("Sorry, you can't delete off days for past months.");
      return;
    }
  
    if (!isMonthSelected) {
      // If the month is selected, add all days of the month as off days
      const monthIndex = months.indexOf(month);
      const allDays = [...Array(31).keys()].map((dayIndex) => {
        const date = new Date(currentYear, monthIndex, dayIndex + 1);
        return date.toISOString().split('T')[0]; // Formatting date as YYYY-MM-DD
      });
      setOffDays((prev) => [...prev, ...allDays]); // Append all days as off days
    } else {
      // If the month is unchecked, delete off days for that month
      const fullMonthDate = `${currentYear}-${(selectedMonthIndex + 1).toString().padStart(2, '0')}`; // Format as "YYYY-MM"
  
      // Check if the selected month is in the past
      if (selectedMonthIndex < currentMonth && currentYear === new Date().getFullYear()) {
        alert("Sorry, you can't delete off days for past months.");
        return;
      }
  
      // Call the API to delete off days for that month
      try {
        const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
          action: "delete_month_off_day",  // Action for deleting full month off days
          api_key: "1",                    // API key
          provider_id: userId,             // Provider ID
          date: fullMonthDate,             // The month in YYYY-MM format
        });
  
        if (response.data.status === "true") {
          setSuccessMessage(`Delete Full Month ${month} Successfully!`);
          fetchOffDays(); // Refresh off days after deletion
        } else {
          alert("Failed to delete off days for the month.");
        }
      } catch (error) {
        console.error("Error deleting off days for the month:", error);
        alert("An error occurred while deleting off days for the month.");
      }
      // finally {
      //   setLoading(false);
      // }
    }
  
    // Reset the selected month
    setSelectedMonth(!isMonthSelected ? month : null);
  };
  

  const isDayHoliday = (month, dayNumber) => {
    const formattedDate = new Date(
      new Date().getFullYear(),
      months.indexOf(month),
      dayNumber
    )
      .toISOString()
      .split("T")[0];

    // Check if the date exists in the offDays array
    return (
      offDays.some((offDay) => offDay?.off_date === formattedDate) ||
      (fullMonth[month] &&
        months.indexOf(month) === months.indexOf(selectedMonth)) // Check if the full month is selected and add all days as holiday
    );
  };
  const isDaySelected = (month, dayNumber) => {
    if (selectedMonth) {
      return months.indexOf(selectedMonth) === months.indexOf(month); // If month is selected, all days in that month should be highlighted
    }
    return (
      selectedDate ===
      new Date(new Date().getFullYear(), months.indexOf(month), dayNumber)
        .toISOString()
        .split("T")[0]
    ); // Check for individual day selection
  };
  const toggleAvailability = async (weekid, weekdayid, provider_id, provider_schedule_type, currentStatus) => {
    setLoading(true);
    const weekId = selectedWeekId; // Yahan week_id ko dynamic value milega
    const off_day = currentStatus === "Y" ? "N" : "Y";
    try {
        const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
            action: "change_off_day",
            api_key: "1",
            weekid: weekId,         // Use parameter directly
            weekdayid: weekdayid,   // Ensure correct parameter name (lowercase 'd')
            provider_id: userId,    // Use userId from component state
            provider_schedule_type: provider_schedule_type,
            off_day: off_day,
        });
  
      if (response.data.status === "true") {
        setSuccessMessage("Availability toggled successfully!");
        // alert("Availability toggled successfully!");
  
        // Update the availability data in the state to reflect the change
        setAvailabilityData(prevData =>
          prevData.map(item => {
            if (item.week_id === weekid && item.weekday_id === weekdayid && item.provider_id === provider_id) {
              return { ...item, off_day: off_day }; // Update the off_day status
            }
            return item;
          })
        );
  
        // Optionally, you can also re-fetch the entire availability data
        // fetchAvailabilityData(userId); // Assuming userId is available in the scope
      } else {
        alert("Failed to toggle availability: " + response.data.response);
      }
    } catch (error) {
      console.error("Error toggling availability:", error);
      alert("Error toggling availability.");
    }
    finally {
      setLoading(false);
    }
  };

  const toggleDay = (month, dayNumber) => {
    // setLoading(true);
    const date = new Date(); // Current date
    const selectedDate = new Date(
      date.getFullYear(),
      months.indexOf(month),
      dayNumber
    ); // Construct the selected date
    setSelectedDate(selectedDate.toISOString().split("T")[0]); // Format it as 'YYYY-MM-DD'
    console.log(`Selected Date: ${selectedDate.toISOString().split("T")[0]}`);
  };
  // const handleAddOffDay = async () => {
  //   if (!selectedDate) {
  //     alert("Please select a date for your off day.");
  //     return;
  //   }
  //     const selectedDateObj = new Date(selectedDate);
  //     const currentDateObj = new Date();
  //     if (selectedDateObj < currentDateObj) {
  //     alert("Sorry, you can't add off days in the past.");
  //     return;
  //   }
  //   try {
  //     const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
  //       action: "add_off_day", // Action to add an off day
  //       api_key: "1", // API key
  //       prov_id: userId, // User ID from localStorage
  //       date: selectedDate,
  //     });
  //     if (response.data.status === "true") {
  //       setSuccessMessage("Add Off Day Successfully!");

  //       // alert("Off day added successfully!");
  //       fetchOffTimes(); // Refresh off times after adding
  //     } else {
  //       alert("Failed to add off day.");
  //     }
  //   } catch (error) {
  //     console.error("Error adding off day:", error);
  //     alert("An error occurred while adding the off day.");
  //   }
  //   // finally {
  //   //   setLoading(false);
  //   // }
  // };
  const handleAddOffDay = async () => {
    if (!selectedDate) {
      alert("Please select a date for your off day.");
      return;
    }
    const selectedDateObj = new Date(selectedDate);
    const currentDateObj = new Date();
    if (selectedDateObj < currentDateObj) {
      alert("Sorry, you can't add off days in the past.");
      return;
    }
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "add_off_day", // Action to add an off day
        api_key: "1", // API key
        prov_id: userId, // User ID from localStorage
        date: selectedDate,
      });
      if (response.data.status === "true") {
        setSuccessMessage("Add Off Day Successfully!");
        // Assuming the new off day is returned in response.data.data
        const newOffDay = response.data.data;
        setOffDays((prevOffDays) => [...prevOffDays, newOffDay]); // Directly add the new off day to state
      } else {
        alert("Failed to add off day.");
      }
    } catch (error) {
      console.error("Error adding off day:", error);
      alert("An error occurred while adding the off day.");
    }
  };
  
  const handleAddOffFullMonth = async () => {
    setLoading(true);
    if (!selectedMonth) {
      alert("Please select a month for your off days.");
      return;
    }
    const currentMonth = new Date().getMonth();
  const selectedMonthIndex = months.indexOf(selectedMonth);
  if (selectedMonthIndex < currentMonth) {
    alert("Sorry, you can't add off days for past months.");
    return;
  }
    const year = new Date().getFullYear();
    const fullMonth = `${year}-${months.indexOf(selectedMonth) + 1}`.padStart(
      7,
      "0"
    ); // e.g. "2025-03"
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "add_month_off_day", // Action to add off days for the full month
        api_key: "1", // Your API key
        provider_id: userId, // Provider ID (userId)
        date: fullMonth, // Send just the formatted "YYYY-MM" string
      });

      if (response.data.status === "true") {
        setSuccessMessage("Add Month Off Day Successfully!");
        alert("Off days for the full month added successfully!");
      } else {
        alert("Failed to add off days for the full month.");
      }
    } catch (error) {
      console.error("Error adding off days for the full month:", error);
      alert("An error occurred while adding off days for the full month.");
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "OFF DAYS" && userId) {
      fetchOffDays(); // Fetch off days data when tab is active
    }
  }, [activeTab, userId]);

  const fetchOffDays = async () => {
    setIsLoading(true); // Set loading state
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "get_off_day", // Action to get off days
        api_key: "1", // API key
        staff_id: userId, // Fetch for the current user
      });
      if (response.data.status === "true") {
        const fetchedOffDays = response.data.data || [];
        setOffDays(fetchedOffDays); // Store off days data

        // Check if full month is selected for any of the fetched off days
        const monthsWithOffDays = fetchedOffDays.map((offDay) => {
          const monthIndex = new Date(offDay?.off_date).getMonth();
          return months[monthIndex]; // Get the month name
        });

        // Update fullMonth state based on fetched off days
        const newFullMonth = {};
        monthsWithOffDays.forEach((month) => {
          newFullMonth[month] = true; // Mark months with off days as selected
        });
        setFullMonth(newFullMonth);
      } else {
        setOffDays([]); // No off days found
      }
    } catch (error) {
      console.error("Error fetching off days:", error);
      alert("Failed to load off days. Please try again.");
    }
    finally {
      setLoading(false);
    }
    // setIsLoading(false);
  };

  const handleDeleteOffDay = async (offDay) => {
    setIsLoading(true); // Set loading state
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "delete_off_day", // API action to delete an off day
        api_key: "1", // API key
        user_id: userId, // User ID (from localStorage)
        date: offDay.off_date, // The actual off day date to delete (corrected)
        id: offDay.id, // The off day ID to uniquely identify it
      });
      if (response.data.status === "true") {
        setSuccessMessage("Delete Off Day Successfully!");
        alert("Off day deleted successfully!");
        fetchOffDays(); // Refresh the off days data after successful deletion
      } else {
        alert("Failed to delete off day.");
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error deleting off day:", error);
      alert("An error occurred while deleting the off day.");
      // setIsLoading(false);
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchedUserId = sessionStorage.getItem("userId");
    console.log("Fetched userId:", fetchedUserId); // Check what is logged
    if (fetchedUserId) {
      setUserId(fetchedUserId);
      fetchAvailabilityData(fetchedUserId);
    }
  }, []);
  const fetchAvailabilityData = async (providerId) => {
    setIsLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "get_schedule_all_data",
        provider_id: providerId,
      });
      console.log("API Response:", JSON.stringify(response.data)); // Log the full response data
      if (response.data.status !== "true") {
        alert("Error: " + response.data.response);
        return;
      }
      const data = Array.isArray(response.data.response)
        ? response.data.response
        : [];
      setAvailabilityData(data);
      console.log("Availability Data:", JSON.stringify(data)); // Log the availability data

      if (data.length > 0) {
        setScheduleType(data[0].provider_schedule_type || null);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching availability data:", error);
      alert("Failed to load schedule data.");
      // setIsLoading(false);
    }
    finally {
      setLoading(false);
    }
  };
  const handleToggleChange = async () => {
    setLoading(true);
    const newScheduleType = scheduleType === "weekly" ? "monthly" : "weekly";
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "change_schedule_type",
        api_key: "1", // Replace with actual API key
        values: newScheduleType,
        staff_id: userId,
      });
      if (response.data.status === "true") {
        setSuccessMessage("Schedule type updated successfully!");
        alert("Schedule type updated successfully!");
        setScheduleType(newScheduleType);
        setSelectedWeek("1"); // Reset to first week when switching schedule type
        fetchAvailabilityData(userId); // Re-fetch the availability data when schedule type changes
      } else {
        alert("Failed to update schedule type: " + response.data.response);
      }
    } catch (error) {
      console.error("Error updating schedule type:", error);
      alert("Error updating schedule type");
    }
    finally {
      setLoading(false);
    }
  };
  const handleWeekChange = (e) => {
    const newSelectedWeek = e.target.value;
    setSelectedWeek(newSelectedWeek); // Update selected week
    setSelectedWeekId(newSelectedWeek); // Update selected week id (can be different if required)
  };
  const filteredDataByWeek = () => {
    if (!availabilityData || availabilityData.length === 0) {
      return [];
    }
    return availabilityData.filter(
      (item) =>
        item.provider_schedule_type === scheduleType &&
        parseInt(item.week_id) === parseInt(selectedWeek) // This will use selectedWeek for filtering
    );
  };

  // const handleAddBreak = async (weekdayId) => {
  //   const weekId = selectedWeekId;
  //   const startTime = breakTimes[weekdayId]?.startTime;
  //   const endTime = breakTimes[weekdayId]?.endTime;
  //   setLoading(true);
  //   if (!startTime || !endTime) {
  //     alert("Please select both start and end times for this day.");
  //     return;
  //   }
  
  //   try {
  //     const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
  //       action: "add_break",
  //       api_key: "1",
  //       weekid: weekId,
  //       weekday: weekdayId,
  //       staff_id: userId,
  //       starttime: startTime,
  //       endtime: endTime,
  //     });
  
  //     if (response.data.status === "true") {
  //       setSuccessMessage("Break added successfully!");
  //       fetchAvailabilityData(userId);
  //     } else {
  //       alert("Failed to add break: " + response.data.response);
  //     }
  //   } catch (error) {
  //     console.error("Error adding break:", error);
  //     alert("Error adding break.");
  //   }
  //   finally {
  //     setLoading(false);
  //   }
  // };
  
  const handleAddBreak = async (weekdayId) => {
    const weekId = selectedWeekId;
    const startTime = breakTimes[weekdayId]?.startTime;
    const endTime = breakTimes[weekdayId]?.endTime;
    setLoading(true);
    if (!startTime || !endTime) {
      alert("Please select both start and end times for this day.");
      return;
    }
  
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "add_break",
        api_key: "1",
        weekid: weekId,
        weekday: weekdayId,
        staff_id: userId,
        starttime: startTime,
        endtime: endTime,
      });
  
      if (response.data.status === "true") {
        setSuccessMessage("Break added successfully!");
        // Assuming the new break is returned in response.data.data
        const newBreak = response.data.data;
        setBreakData((prevBreakData) => [...prevBreakData, newBreak]); // Directly add the new break to state
      } else {
        alert("Failed to add break.");
      }
    } catch (error) {
      console.error("Error adding break:", error);
      alert("Error adding break.");
    } finally {
      setLoading(false);
    }
  };
  
  const fetchBreakData = async () => {
    setLoading(true);
    console.log("userId for fetchBreakData:", userId); // Check userId before making API call
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "get_break",
        api_key: "1",
        staff_id: userId, // Ensure userId is being passed here
        week_id: selectedWeekId,
        // weekday_id: selectedWeek,
      });
      if (response.data.status === "true") {
        setBreakData(response.data.data); // Store break data in state
      } else {
        setBreakData([]); // No breaks found
      }
    } catch (error) {
      console.error("Error fetching break data:", error);
      alert("Failed to load break data. Please try again.");
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (userId) {
      fetchBreakData(); // Only call if userId is available
    }
  }, [activeTab, selectedWeekId, userId]); // Add userId to dependencies
  const handleConfirmDelete = async () => {
    if (!selectedBreakId) return;
    setIsLoading(true);
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "delete_break",
        api_key: "1",
        id: selectedBreakId,
      });
      if (response.data.status === "true") {
        setSuccessMessage("Break deleted successfully!");
        alert("Break deleted successfully!");
        fetchBreakData(); // Refresh breaks data
      } else {
        alert("Failed to delete break.");
      }
      setIsLoading(false);
      setShowDeleteModal(false); // Close the modal
    } catch (error) {
      console.error("Error deleting break:", error);
      alert("An error occurred while deleting the break.");
      // setIsLoading(false);
      setShowDeleteModal(false); // Close the modal
    }
    finally {
      setLoading(false);
    }
  };
  // const handleAddOffTime = async () => {
  //   setLoading(true);
  //   if (!startDateTime || !endDateTime) {
  //     alert("Please select both start date and end date.");
  //     return;
  //   }
  //   try {
  //     const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
  //       action: "add_offtime", // Action for the API
  //       api_key: "1", // API key
  //       startdate: startDateTime, // Start date-time from the input
  //       enddate: endDateTime, // End date-time from the input
  //       staff_id: userId, // User ID (staff_id) from state
  //     });
  //     if (response.data.status === "true") {
  //       setSuccessMessage("Add Off Time Successfully!");
  //       alert("Off time added successfully!");
  //     } else {
  //       alert("Failed to add off time.");
  //     }
  //   } catch (error) {
  //     console.error("Error adding off time:", error);
  //     alert("An error occurred while adding the off time.");
  //   }
  //   finally {
  //     setLoading(false);
  //   }
  // };

  const handleAddOffTime = async () => {
    setLoading(true);
    if (!startDateTime || !endDateTime) {
      alert("Please select both start date and end date.");
      return;
    }
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "add_offtime", // Action for the API
        api_key: "1", // API key
        startdate: startDateTime, // Start date-time from the input
        enddate: endDateTime, // End date-time from the input
        staff_id: userId, // User ID (staff_id) from state
      });
      if (response.data.status === "true") {
        setSuccessMessage("Off time added successfully!");
  
        // Directly update the local state without fetching again
        setOffTimes((prevOffTimes) => [
          ...prevOffTimes,
          {
            id: response.data.id, // Assuming the response contains the new off time ID
            start_date: startDateTime,
            start_time: startDateTime,
            end_date: endDateTime,
            end_time: endDateTime,
          },
        ]);
  
        // Clear the input fields
        setStartDateTime("");
        setEndDateTime("");
      } else {
        alert("Failed to add off time.");
      }
    } catch (error) {
      console.error("Error adding off time:", error);
      alert("An error occurred while adding the off time.");
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    if (activeTab === "OFF TIME" && userId) {
      fetchOffTimes(); // Fetch off times data when tab is active
    }
  }, [activeTab, userId]);
  const fetchOffTimes = async () => {
    setIsLoading(true); // Set loading state to true while fetching
    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/schedule.php`, // Endpoint for getmy_offtimes
        {
          action: "getmy_offtimes",
          api_key: "1", // API key
          staff_id: userId, // Pass userId dynamically here
        }
      );
      console.log("API Response:", response.data); // Log the API response to inspect the structure

      // Check if the response status is true and update the state
      if (response.data.status === "true") {
        setOffTimes(response.data.response || []); // Set fetched off time data
      } else {
        setOffTimes([]); // No off times found, set an empty array
      }
    } catch (error) {
      console.error("Error fetching off times:", error);
      alert("Failed to load off time data. Please try again.");
    }
    finally {
      setLoading(false);
    }
    // setIsLoading(false); // Set loading state to false once fetching is complete
  };
  // Handle delete confirmation modal
  const handleDelete = (offTimeId) => {
    setDeleteItemId(offTimeId); // Store the ID of the off time to delete
    setShowDeleteModaloff(true); // Show the modal
  };
  // Confirm deletion
  const confirmDelete = async () => {
    if (!deleteItemId) return;
    setIsLoading(true); // Show loading state during API call
    try {
      const response = await axios.post(`${BaseUrl}/backend/api/schedule.php`, {
        action: "delete_offtime",
        api_key: "1", // API key
        id: deleteItemId, // Pass the off time ID to delete
      });
      if (response.data.status === "true") {
        setSuccessMessage("Off time deleted successfully!");
        // alert("Off time deleted successfully!");
        fetchOffTimes(); // Re-fetch the off times to update the list
      } else {
        alert("Failed to delete off time.");
      }
      setIsLoading(false);
      setShowDeleteModaloff(false); // Close the modal after deletion
    } catch (error) {
      console.error("Error deleting off time:", error);
      alert("An error occurred while deleting the off time.");
      // setIsLoading(false);
      setShowDeleteModaloff(false); // Close the modal even on error
    }
    finally {
      setLoading(false);
    }
  };
  const cancelDelete = () => {
    setShowDeleteModaloff(false); // Close the modal
  };
  const handleDeleteBreak = (breakId) => {
    setSelectedBreakId(breakId); // Save the break id to be deleted
    setShowDeleteModal(true); // Show the modal for confirmation
  };
  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="container mx-auto    bg-white ">
         {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      {/* Tabs */}
      <div className="flex flex-wrap justify-center border-b sm:border-b-4 md:border-b-8 border-gray-300 pb-4 mb-6 pt-3 overflow-x-auto">
        <div className="flex flex-col items-center w-full">
          {/* For mobile screens */}
          <div className="lg:hidden w-full px-4">
            <select
              value={activeTab}
              onChange={(e) => setActiveTab(e.target.value)}
              className="block w-full mx-auto py-2 text-base border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              {[
                "VIEW SLOTS BY ? ",
                "AVAILABILITY",
                "ADD BREAKS",
                "OFF TIME",
                "OFF DAYS",
              ].map((tab) => (
                <option key={tab} value={tab}>
                  {tab}
                </option>
              ))}
            </select>
          </div>

          {/* For laptop and tablet screens */}
          <div className="hidden lg:flex flex-row justify-around w-full gap-x-[20px]">
            {[
             "VIEW SLOTS BY ? ",
              "AVAILABILITY",
              "ADD BREAKS",
              "OFF TIME",
              "OFF DAYS",
            ].map((tab) => (
              <button
                key={tab}
                className={`text-center px-[15px] py-[8px] text-xs sm:text-sm font-medium rounded-lg transition-colors duration-[300ms] ease-in-out ${
                  activeTab === tab
                    ? "bg-blue-[#3498db] border-b-[4px] border-blue-[#3498db] font-semibold "
                    : "border-b-[4px] border-transparent text-gray[-600 hover:text-blue[400 hover:border-blue[300 bg-slate[-50]"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Tab Content */}
      <div className="p-2 sm:p-6">
        {/* VIEW SLOTS BY? Tab */}
        {activeTab === "VIEW SLOTS BY ? " && (
          <div className="p-4">
            <div className="flex items-center space-x-2">
              <label htmlFor="schedule" className="text-lg font-medium">
                Schedule Type
              </label>
              <div className="relative flex items-center">
                <label
                  htmlFor="toggle"
                  className="inline-flex relative items-center cursor-pointer"
                >
                  <input
                    type="checkbox"
                    id="toggle"
                    className="sr-only"
                    checked={scheduleType === "weekly"}
                    onChange={handleToggleChange}
                  />
                  <div className="w-20 h-8 bg-gray-200 rounded-full transition-all duration-300 ease-in-out">
                    <div
                      className={`w-8 h-8 bg-white rounded-full transition-all duration-300 ease-in-out transform ${
                        scheduleType === "weekly"
                          ? "translate-x-10"
                          : "translate-x-0"
                      }`}
                    ></div>
                  </div>
                  <span
                    className={`absolute left-1/2 transform -translate-x-2/4 text-black text-xs font-medium ${
                      scheduleType === "monthly" ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    Monthly
                  </span>
                  <span
                    className={`absolute transform translate-x-1/4 text-black text-xs font-medium ${
                      scheduleType === "weekly" ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    Weekly
                  </span>
                </label>
              </div>
            </div>
          </div>
        )}
        {/* AVAILABILITY Tab */}
        {activeTab === "AVAILABILITY" && (
          <div>
            {/* Week Dropdown */}
            <div className="mb-4">
              {scheduleType === "weekly" ? (
                <span>This Week</span> // Show "This Week" for weekly schedule
              ) : (
                <select
                  className="bg-white border-gray-300 rounded-lg p-2"
                  value={selectedWeek}
                  onChange={handleWeekChange} // This will update selectedWeek when changed
                >
                  <option value="1">First Week</option>
                  <option value="2">Second Week</option>
                  <option value="3">Third Week</option>
                  <option value="4">Fourth Week</option>
                  <option value="5">Fifth Week</option>
                </select>
              )}
            </div>
            {/* Display Selected Week */}
            <div className="mb-4">
              <h3 className="text-lg font-semibold">
                Selected Week:{" "}
                {selectedWeek === "1"
                  ? "First Week"
                  : selectedWeek === "2"
                  ? "Second Week"
                  : selectedWeek === "3"
                  ? "Third Week"
                  : selectedWeek === "4"
                  ? "Fourth Week"
                  : "Fifth Week"}
              </h3>
            </div>
            {/* Availability Table */}
            <div className="overflow-x-auto mt-12">
              <table className="min-w-full border-collapse border shadow-lg rounded-xl">
                <thead>
                  <tr className="bg-blue-200">
                    <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                      Day
                    </th>
                    <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                      Status
                    </th>
                    <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                      Start Time
                    </th>
                    <th className="border border-blue-300 px-2 sm:px-6 py-3 text-left text-blue-800 text-sm sm:text-base">
                      End Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {availabilityData && availabilityData.length > 0 ? (
                    filteredDataByWeek().map((item, index) => (
                      <tr key={item.id || index} className="hover:bg-blue-100">
                        <td className="border border-blue-300 px-2 sm:px-6 py-3 text-blue-700 text-sm sm:text-base">
                          {item.weekday_id ? `Day ${item.weekday_id}` : "N/A"}
                        </td>
                        <td className="border border-blue-300 px-2 sm:px-6 py-3">
                          <button
                            // When using in your component
                            onClick={() =>
                              toggleAvailability(
                                item.week_id,
                                item.weekday_id,
                                userId, // Pass current user ID
                                item.provider_schedule_type,
                                item.off_day
                              )
                            }
                            className={`relative w-12 h-6 rounded-full transition-all duration-300 flex items-center justify-center text-sm ${
                              item.off_day === "N"
                                ? "bg-green-500"
                                : "bg-gray-400"
                            }`}
                          >
                            <div
                              className={`w-6 h-6 bg-white rounded-full absolute top transition-all ${
                                item.off_day === "N" ? "right-0.5" : "left-0.5"
                              }`}
                            />
                          </button>
                        </td>
                        <td className="border border-blue-300 px-2 sm:px-6 py-3 text-blue-700 text-sm sm:text-base">
                          {item.day_start_time || "N/A"}{" "}
                          {/* Replace with correct field */}
                        </td>
                        <td className="border border-blue-300 px-2 sm:px-6 py-3 text-blue-700 text-sm sm:text-base">
                          {item.day_end_time || "N/A"}{" "}
                          {/* Replace with correct field */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        className="text-center px-6 py-4 text-sm sm:text-base"
                      >
                        No availability data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {activeTab === "ADD BREAKS" && (
          <div className="w-full px-2 sm:px-0">
            <div className="mb-4 w-full">
              {scheduleType === "weekly" ? (
                <span className="font-semibold text-lg block w-full">
                  This Week
                </span>
              ) : (
                <select
                  className="bg-white border-gray-300 rounded-lg p-2 w-full"
                  value={selectedWeek}
                  onChange={handleWeekChange}
                >
                  <option value="1">First Week</option>
                  <option value="2">Second Week</option>
                  <option value="3">Third Week</option>
                  <option value="4">Fourth Week</option>
                  <option value="5">Fifth Week</option>
                </select>
              )}
            </div>

            {/* Desktop Table View - Hidden on mobile */}
            <div className="hidden md:block overflow-x-auto mt-8">
              <table className="min-w-full border-collapse border shadow-lg rounded-xl">
                <thead>
                  <tr className="bg-blue-200">
                    <th className="border px-6 py-3 text-left">Day</th>
                    <th className="border px-6 py-3 text-left">Add Break</th>
                    <th className="border px-6 py-3 text-left">Time</th>
                    <th className="border px-6 py-3 text-left">
                      Start & End Time
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    filteredDataByWeek().map((item) => (
                      <tr key={item.id} className="hover:bg-blue-100">
                        <td className="border px-6 py-3 text-blue-700">
                          {item.weekday_id ? `Day ${item.weekday_id}` : "N/A"}
                        </td>
                        <td className="border px-6 py-3">
                          {item.off_day === "N" && ( // Only show button if not an off day
                            <button
                              onClick={() => handleAddBreak(item.weekday_id)}
                              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded"
                            >
                              Add Break
                            </button>
                          )}

                          {/* Display off day status */}
                          {item.off_day === "Y" && (
                            <div className="bg-red-100 text-red-600 py-1 px-2 rounded">
                              Marked as Off Day
                            </div>
                          )}
                        </td>
                        <td className="border px-6 py-3">
                          {item.off_day === "N" && (
                            <div className="flex space-x-2">
                              <input
                                type="time"
                                value={
                                  breakTimes[item.weekday_id]?.startTime || ""
                                }
                                onChange={(e) =>
                                  setBreakTimes((prev) => ({
                                    ...prev,
                                    [item.weekday_id]: {
                                      ...prev[item.weekday_id],
                                      startTime: e.target.value,
                                    },
                                  }))
                                }
                                className="w-28 border border-gray-300 rounded-lg px-2 py-2"
                              />
                              <span>-</span>
                              <input
                                type="time"
                                value={
                                  breakTimes[item.weekday_id]?.endTime || ""
                                }
                                onChange={(e) =>
                                  setBreakTimes((prev) => ({
                                    ...prev,
                                    [item.weekday_id]: {
                                      ...prev[item.weekday_id],
                                      endTime: e.target.value,
                                    },
                                  }))
                                }
                                className="w-28 border border-gray-300 rounded-lg px-2 py-2"
                              />
                            </div>
                          )}
                        </td>
                        <td className="border px-6 py-3 text-blue-700">
                          {breakData.length > 0 && (
                            <div className="p-2 border border-gray-400 rounded-md flex space-x-2 items-center">
                              {breakData.map(
                                (breakItem) =>
                                  breakItem.weekday_id === item.weekday_id && (
                                    <div
                                      key={breakItem.id}
                                      className="flex items-center"
                                    >
                                      <span className="font-semibold text-blue-600">
                                        {breakItem.break_start}
                                      </span>
                                      <span className="mx-2 text-gray-500">
                                        -
                                      </span>
                                      <span className="font-semibold text-blue-600">
                                        {breakItem.break_end}
                                      </span>
                                      <button
                                        onClick={() =>
                                          handleDeleteBreak(breakItem.id)
                                        }
                                        className="text-red-600 ml-2"
                                      >
                                        <RiDeleteBin5Line size={20} />
                                      </button>
                                    </div>
                                  )
                              )}
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>

            {/* Mobile Card View - Visible only on mobile */}
            <div className="md:hidden w-full">
           
                <div className="w-full space-y-4">
                  {filteredDataByWeek().map((item) => (
                    <div
                      key={item.id}
                      className="bg-white rounded-lg shadow w-full overflow-hidden border border-gray-200"
                    >
                      {/* Card Header with Day */}
                      <div className="bg-blue-200 p-3 font-semibold text-blue-800 w-full">
                        {item.weekday_id ? `Day ${item.weekday_id}` : "N/A"}
                      </div>

                      {/* Card Body */}
                      <div className="p-4 w-full">
                        {/* Time Input Section */}
                        <div className="mb-4 w-full">
                          <label className="block text-gray-700 text-sm font-bold mb-2 w-full">
                            Break Time
                          </label>
                          <div className="flex flex-col sm:flex-row w-full space-y-2 sm:space-y-0 sm:space-x-2">
                            <div className="flex w-full items-center space-x-2">
                              <input
                                type="time"
                                value={
                                  breakTimes[item.weekday_id]?.startTime || ""
                                }
                                onChange={(e) =>
                                  setBreakTimes((prev) => ({
                                    ...prev,
                                    [item.weekday_id]: {
                                      ...prev[item.weekday_id],
                                      startTime: e.target.value,
                                    },
                                  }))
                                }
                                className="w-28 border border-gray-300 rounded-lg px-2 py-2"
                              />
                              <span className="px-1">-</span>
                              <input
                                type="time"
                                value={
                                  breakTimes[item.weekday_id]?.endTime || ""
                                }
                                onChange={(e) =>
                                  setBreakTimes((prev) => ({
                                    ...prev,
                                    [item.weekday_id]: {
                                      ...prev[item.weekday_id],
                                      endTime: e.target.value,
                                    },
                                  }))
                                }
                                className="w-28 border border-gray-300 rounded-lg px-2 py-2"
                              />
                            </div>
                          </div>
                        </div>

                        {/* Add Break Button */}
                        <button
                          onClick={() => handleAddBreak(item.weekday_id)}
                          className="w-full px-4 py-3 bg-blue-500 text-white rounded-lg text-sm font-medium"
                        >
                          Add Break
                        </button>

                        {/* Existing Breaks */}
                        {breakData.length > 0 &&
                          breakData.some(
                            (breakItem) =>
                              breakItem.weekday_id === item.weekday_id
                          ) && (
                            <div className="mt-4 w-full">
                              <h3 className="text-sm font-bold text-gray-700 mb-2">
                                Current Breaks
                              </h3>
                              <div className="space-y-2 w-full">
                                {breakData.map(
                                  (breakItem) =>
                                    breakItem.weekday_id ===
                                      item.weekday_id && (
                                      <div
                                        key={breakItem.id}
                                        className="p-3 border border-gray-300 rounded-md flex justify-between items-center w-full"
                                      >
                                        <div>
                                          <span className="font-semibold text-blue-600">
                                            {breakItem.break_start}
                                          </span>
                                          <span className="mx-2 text-gray-500">
                                            -
                                          </span>
                                          <span className="font-semibold text-blue-600">
                                            {breakItem.break_end}
                                          </span>
                                        </div>
                                        <button
                                          onClick={() =>
                                            handleDeleteBreak(breakItem.id)
                                          }
                                          className="text-red-600 p-2"
                                          aria-label="Delete break"
                                        >
                                          <RiDeleteBin5Line size={22} />
                                        </button>
                                      </div>
                                    )
                                )}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  ))}
                </div>
             
            </div>
          </div>
        )}
        {showDeleteModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
              <h2 className="text-lg font-semibold text-gray-700 mb-4">
                Are you sure you want to delete this item?
              </h2>
              <div className="flex justify-end gap-x-4  ">
                <button
                  onClick={handleConfirmDelete}
                  className="bg-red-600 text-white px-4 py-2 rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={() => setShowDeleteModal(false)} // Close the modal without deleting
                  className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
        {activeTab === "OFF TIME" && (
          <div className="p-1 sm:p-6 space-y-6 sm:space-y-12 w-full max-w-4xl mx-auto">
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-8">
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 text-center sm:text-left">
                Add Your OFF Time
              </h2>
            </div>

            {/* Calendar Section */}
            <div className="flex flex-col gap-4 sm:gap-8">
              <div className="w-full border border-gray-300 rounded-lg shadow-sm p-4">
                <label className="block text-gray-700 font-medium mb-2">
                  Add New Off Time
                </label>
                <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center w-full">
                  <input
                    type="datetime-local"
                    value={startDateTime}
                    onChange={(e) => setStartDateTime(e.target.value)}
                    className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 w-full sm:w-auto"
                  />
                  <span className="text-gray-500 sm:mx-2">to</span>
                  <input
                    type="datetime-local"
                    value={endDateTime}
                    onChange={(e) => setEndDateTime(e.target.value)}
                    className="p-2 border border-gray-300 rounded-md focus:border-blue-500 focus:ring focus:ring-blue-200 w-full sm:w-auto"
                  />
                  <button
                    onClick={handleAddOffTime}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 w-full sm:w-auto"
                  >
                    Apply
                  </button>
                  <button className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 w-full sm:w-auto">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            {/* Added Off Times Table */}
            <div className="mt-6 sm:mt-12">
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 mb-4 text-center sm:text-left">
                Your Added OFF Times
              </h2>
              <div className="overflow-x-auto rounded-lg shadow w-full">
                <table className="w-full border-collapse bg-white text-sm sm:text-base">
                  <thead>
                    <tr className="bg-gray-100 text-left">
                      <th className="px-2 sm:px-4 py-2">#</th>
                      <th className="px-2 sm:px-4 py-2">Start Date</th>
                      <th className="px-2 sm:px-4 py-2">Start Time</th>
                      <th className="px-2 sm:px-4 py-2">End Date</th>
                      <th className="px-2 sm:px-4 py-2">End Time</th>
                      <th className="px-2 sm:px-4 py-2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {offTimes.length > 0 ? (
                      offTimes.map((offTime, index) => (
                        <tr
                          key={offTime?.id}
                          className="border-b hover:bg-gray-50 text-center"
                        >
                          <td className="px-2 sm:px-4 py-2">{index + 1}</td>
                          <td className="px-2 sm:px-4 py-2">
                            {offTime?.start_date}
                          </td>
                          <td className="px-2 sm:px-4 py-2">
                            {offTime?.start_time}
                          </td>
                          <td className="px-2 sm:px-4 py-2">
                            {offTime?.end_date}
                          </td>
                          <td className="px-2 sm:px-4 py-2">
                            {offTime?.end_time}
                          </td>
                          <td className="px-2 sm:px-4 py-2">
                            <button
                              onClick={() => handleDelete(offTime.id)}
                              className="text-red-600 hover:text-red-800"
                            >
                              <RiDeleteBin5Line size={20} />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={6}
                          className="px-4 py-2 text-center text-gray-500"
                        >
                          No off time data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Delete Confirmation Modal */}
            {showDeleteModaloff && (
              <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-500 bg-opacity-50 p-4">
                <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
                  <h2 className="text-lg font-semibold text-gray-800">
                    Are you sure you want to delete this off time?
                  </h2> 
                  <div className="mt-4 flex flex-col sm:flex-row justify-end gap-4">
                    <button
                      onClick={confirmDelete}
                      className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                    >
                      Yes
                    </button>
                    <button
                      onClick={cancelDelete}
                      className="w-full sm:w-auto px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {/* {activeTab === "OFF DAYS" && (
          <div className="p-2 sm:p-6 space-y-6 sm:space-y-12">
  
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800">
                Select Your Off Days
              </h2>
         
              <div className="flex gap-4">
                <button
                  onClick={handleAddOffDay}
                  className="px-4 sm:px-6 py-2 bg-blue-500 text-white rounded-lg text-sm sm:text-lg font-semibold hover:bg-blue-600"
                >
                  Add Off Day
                </button>
                <button
                  onClick={handleAddOffFullMonth}
                  className="px-4 sm:px-6 py-2 bg-blue-500 text-white rounded-lg text-sm sm:text-lg font-semibold hover:bg-blue-600"
                >
                  Add Off Full Month
                </button>
              </div>
            </div>

   
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2  xl:grid-cols-3   gap-4 sm:gap-8">
              {months.map((month) => (
                <div
                  key={month}
                  className="border border-gray-300 rounded-lg p-2 sm:p-4 shadow-sm"
                >
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="text-md sm:text-lg font-bold text-gray-700">
                      {month}
                    </h3>
                    <input
                      type="checkbox"
                      className="h-4 w-4 text-blue-500 focus:ring-blue-400"
                      checked={fullMonth[month] || false}
                      onChange={() => toggleMonth(month)} 
                    />
                  </div>

                  <table className="w-full text-center border-collapse border border-gray-200">
                    <thead>
                      <tr>
                        {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                          (day) => (
                            <th
                              key={day}
                              className="px-1 sm:px-2 py-1 text-xs sm:text-sm font-medium text-gray-600 border border-gray-200"
                            >
                              {day}
                            </th>
                          )
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {[...Array(5)].map((_, weekIndex) => (
                        <tr key={weekIndex}>
                          {[...Array(7)].map((_, dayIndex) => {
                            const dayNumber = weekIndex * 7 + dayIndex - 2; 
                            if (dayNumber <= 0 || dayNumber > 31)
                              return (
                                <td
                                  key={dayIndex}
                                  className="px-1 sm:px-2 py-1 sm:py-2 text-gray-300 border border-gray-200"
                                />
                              ); 

                            const formattedDate = new Date(
                              new Date().getFullYear(),
                              months.indexOf(month),
                              dayNumber
                            )
                              .toISOString()
                              .split("T")[0];
                            const isSelected = isDaySelected(month, dayNumber); 
                            const isHoliday = isDayHoliday(month, dayNumber); 

                            
                            const offDay = offDays.find(
                              (offDay) => offDay?.off_date === formattedDate
                            );

                            return (
                              <td
                                key={dayIndex}
                                className={`px-1 sm:px-2 py-1 sm:py-2 text-xs sm:text-sm ${
                                  isSelected
                                    ? "bg-blue-700 text-white"
                                    : isHoliday && offDay
                                    ? "bg-red-500 text-white cursor-pointer"
                                    : "text-gray-800"
                                } border border-gray-200`}
                                onClick={
                                  () =>
                                    isHoliday && offDay
                                      ? handleDeleteOffDay(offDay) 
                                      : toggleDay(month, dayNumber) 
                                }
                              >
                                {dayNumber}
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))}
            </div>
          </div>
        )} */}
          {activeTab === "OFF DAYS" && (
  <div className="p-2 sm:p-6 space-y-6 sm:space-y-12">
    {/* Header */}
    <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
      <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800">
        Select Your Off Days
      </h2>
      <div className="flex gap-4">
        <button
          onClick={handleAddOffDay}
          className="px-4 sm:px-6 py-2 bg-blue-500 text-white rounded-lg text-sm sm:text-lg font-semibold hover:bg-blue-600"
        >
          Add Off Day
        </button>
        <button
          onClick={handleAddOffFullMonth}
          className="px-4 sm:px-6 py-2 bg-blue-500 text-white rounded-lg text-sm sm:text-lg font-semibold hover:bg-blue-600"
        >
          Add Off Full Month
        </button>
      </div>
    </div>

    {/* Calendar Section */}
    <div className="bg-white border border-gray-300 rounded-lg shadow-sm p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-bold text-gray-800 mb-4">
        Calendar - {new Date().getFullYear()}
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {months.map((month, monthIndex) => {
          const year = new Date().getFullYear();
          const firstDayOfMonth = new Date(year, monthIndex, 1).getDay(); // 0 = Sunday
          const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
          const daysArray = Array.from({ length: daysInMonth }, (_, i) => i + 1);
          const paddingDays = Array(firstDayOfMonth).fill(null); // Empty cells before the 1st day

          return (
            <div
              key={month}
              className="border border-gray-200 rounded-lg p-3 sm:p-4"
            >
              {/* Month Header */}
              <div className="flex justify-between items-center mb-3">
                <h3 className="text-md sm:text-lg font-semibold text-gray-700">
                  {month} {year}
                </h3>
                <input
                  type="checkbox"
                  className="h-4 w-4 text-blue-500 focus:ring-blue-400 rounded"
                  checked={fullMonth[month] || false}
                  onChange={() => toggleMonth(month)}
                />
              </div>

              {/* Calendar Grid */}
              <div className="grid grid-cols-7 gap-1 text-center">
                {/* Weekday Headers */}
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                  <div
                    key={day}
                    className="text-xs sm:text-sm border border-balack-400 rounded-full font-medium text-gray-900 py-1"
                  >
                    {day}
                  </div>
                ))}

                {/* Padding Days */}
                {paddingDays.map((_, index) => (
                  <div
                    key={`padding-${index}`}
                    className="text-xs sm:text-sm border border-gray-200 rounded-full text-gray-300 py-2"
                  />
                ))}

                {/* Actual Days */}
                {daysArray.map((day) => {
                  // Manually construct the date string to avoid timezone issues
                  const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                  const isSelected = selectedDate === formattedDate;
                  const isHoliday = offDays?.some(
                    (offDay) => offDay?.off_date === formattedDate
                  ) || (fullMonth[month] && month === selectedMonth);

                  return (
                    <div
                      key={day}
                      className={`text-xs sm:text-sm py-2 border border-gray-200 rounded-full cursor-pointer transition-colors ${
                        isSelected
                          ? "bg-blue-600 text-white"
                          : isHoliday
                          ? "bg-red-500 text-white"
                          : "text-gray-800 hover:bg-gray-100"
                      }`}
                      onClick={() => {
                        setSelectedDate(formattedDate); // Set the exact date
                        console.log("Selected Date:", formattedDate); // Debug log
                        if (isHoliday) {
                          const offDay = offDays.find(
                            (off) => off.off_date === formattedDate
                          );
                          if (offDay) handleDeleteOffDay(offDay);
                        }
                      }}
                      title={isHoliday ? "Off Day" : ""}
                    >
                      {day}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
)}
      </div>
    </div>
       
  </div>
  );
};
export default SchedulePage_s;

